export const isAppleMobile = () => {
  return typeof window !== 'undefined'
    ? /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
    : false;
};

export const isMobile = () => {
  return typeof window !== 'undefined' ? /Mobi|Android/i.test(navigator.userAgent) : false;
};

export const AppStoreLink =
  'https://apps.apple.com/app/apple-store/id6475769640?pt=126822141&ct=web_app&mt=8';

export const GooglePlayLink =
  'https://play.google.com/store/apps/details?id=com.mindverse.mebot&referrer=utm_source%3Dwebapp';

export const YingYongBaoLink = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.mindverse.mebot';

export const PuGongYingLink = 'https://www.pgyer.com/secondme-android2';

export const CnHomepageDownloadLink = 'https://intro.second-me.cn/downloads';

export const IntlHomepageDownloadLink = 'https://home.second.me/downloads';

export const AndroidApkDownloadLink = 'https://www.mindverse.com/app/secondme-official-latest.apk';
